import type { Occurrence } from '../../../models/occurrence';
import SummaryDialog from '../../kanban/dialogs/summaryDialog';
import type { SummaryProps } from '../types';

interface IOccurrenceSummaryDialogProps {
    occurrence: Occurrence;
    summaryProps: SummaryProps;
    show: boolean;
    onClose: () => void;
}

const OccurrenceSummaryDialog = ({ occurrence, summaryProps, show, onClose }: IOccurrenceSummaryDialogProps) => (
    <SummaryDialog
        showDialog={show}
        onClose={onClose}
        occurrence={occurrence}
        isValidStep={fields => summaryProps.isValidStep(fields, occurrence)}
        loading={summaryProps.loading}
        save={() => summaryProps.save(occurrence)}
        disabledAllFields={summaryProps.disabledAllFields}
        persona={summaryProps.persona}
        finalized={!!occurrence.finished}
        occurrenceStepAvailable={summaryProps.occurrenceStepAvailable}
        partners={summaryProps.partners}
        changeStep={summaryProps.changeStep}
        getNotFilledRequiredFields={summaryProps.getNotFilledRequiredFields}
    />
);

export default OccurrenceSummaryDialog;
